import { post_middleware_olm } from "services/Middleware"
import useCancelToken from "hooks/UseCancelToken"
import Swal from "sweetalert2"
import useAlertSessionError from "./useAlertSessionError"

const useScheduleResources = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const { showAlert } = useAlertSessionError()

  const post_list_schedule_action = async (body: any) => {
    try {
      return await post_middleware_olm("schedule/all", body, newCancelToken())
    } catch (error: any) {
      if (isCancel(error)) return
      if ([401].includes(error?.response?.status)) return showAlert()
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message?.error,
        icon: "error",
      })
    }
  }

  return {
    post_list_schedule_action,
  }
}

export default useScheduleResources
